// services/clubApplicationStatus.js
//
// Fresh "does this user have a PENDING member application to this club?"
// check, run right before Apply / withdraw by the Clubs tab (useClubApply)
// and the club page. A failed query returns { error } (always an Error),
// never an authoritative false: callers must not submit or report
// "not pending" off a network error. Kept out of clubService.js (frozen).

import { ClubService } from "./clubService";

export async function hasPendingApplication(userId, clubId) {
  const { data, error } = await ClubService.getUserApplications(userId);
  if (error) return { data: null, error: error instanceof Error ? error : new Error(String(error)) };
  return {
    data: (data || []).some((app) => app.clubId === clubId && app.status === "pending"),
    error: null,
  };
}
